module.exports = __webpack_public_path__ + "img/showData.b55a982d.png";